import _ from "lodash";
import { IProcessVariable } from "../../processEditor/model/IProcessData";
import { ParameterEditorValue } from "../../processEditor/model/ParameterEditorValue";

import { AgentGroup } from "../../shared/model/AgentGroup";
import { HashMap } from "../../shared/model/HashMap";

export interface Draft {
    name: string;
    id: number;
    modified: string;
    modifier: string;
    processId?: number;
}

export interface Process {
    id: number;
    uri: string;
    name: string;
    description: string;
    uniqueIdentifier: string;
    version: number;
    minorVersion: number;
    majorVersion: number;
    tags: string[];
    modified: string;
    modifier: string;
    isCrossPlatform: boolean;
    isDotNet: boolean;
    triggers: ITriggerDescription[];
    triggersActive: boolean;
    usedTasks: string[];
    promotedResultVariables: string[];
    frendsVersion: string;
    targetFramework: string;
    isPinned: boolean;
    processVariables: IProcessVariable[];
    template: { name: string; uniqueIdentifier: string } | null;
}
export interface ProcessListResponse {
    processCount: number;
    processes: Process[];
}

export interface IBaseProcessReference {
    processName: string;
    processId: number;
    isSubprocess: boolean;
    processGuid: string;
    processVersion: string;
}

export interface IProcessReferenceData extends IBaseProcessReference {
    agentGroups: string[];
}

export interface IAgentGroupWithDisplayName {
    environmentName: string | undefined;
    agentGroupName: string;
    agentGroupDisplayName: string;
}

export class ProcessReferenceModel implements IBaseProcessReference {
    public agentGroupWithDisplayName: IAgentGroupWithDisplayName[];
    public processName: string;
    public processId: number;
    public isSubprocess: boolean;
    public processGuid: string;
    public processVersion: string;
    constructor(processReference: IProcessReferenceData, agentGroupsForProcess: string[], agentGroups: HashMap<AgentGroup>, currentAgentGroup: string) {
        this.processName = processReference.processName;
        this.processId = processReference.processId;
        this.isSubprocess = processReference.isSubprocess;
        this.processGuid = processReference.processGuid;
        this.processVersion = processReference.processVersion;

        let matchingAgentGroups = _.intersection(processReference.agentGroups, agentGroupsForProcess);

        // Local call
        const hasLocalCall = agentGroupsForProcess.some((a) => a === "__localCall");
        const currentProcessDeployedToCurrentAgentGroup = processReference.agentGroups.some((x) => x.toLowerCase() === currentAgentGroup.toLowerCase());
        if (currentProcessDeployedToCurrentAgentGroup && hasLocalCall) {
            matchingAgentGroups = [currentAgentGroup];
        }

        this.agentGroupWithDisplayName = matchingAgentGroups
            .map((agentGroupName) => {
                const agentGroup = agentGroups[agentGroupName];
                if (!agentGroup) {
                    return {
                        environmentName: undefined,
                        agentGroupName: agentGroupName,
                        agentGroupDisplayName: agentGroupName
                    };
                }
                return {
                    environmentName: agentGroup.environment,
                    agentGroupName: agentGroup.name,
                    agentGroupDisplayName: agentGroup.displayName
                };
            });
    }
}
export interface ITriggerParameter {
    name: string;
    isSecret: boolean;
    description: string | undefined;
    nonStringifiedDefaultValue: string | undefined | ParameterEditorValue;
}

export interface ITriggerDescription {
    type: string;
    name: string;
    description: string;
}

export interface IExistingVersions {
    majorVersion: number;
    minorVersion: number;
    versions: number[];
    deployedProcessVersions: IDeployedVersionData[];
    changeDescriptions: IChangeDescriptionByVersion[];
}

export interface IChangeDescriptionByVersion {
    versionNumber: number;
    changeDescription: string;
}

export interface IDeployedVersionData {
    versionNumber: number;
    environmentName: string;
    agentGroupName: string;
}
